export default __webpack_public_path__ + "static/media/DB-logo-white.0c8cf1f9.png";